export enum EditionTypeEnum {
    DeliveryDate = 0,
    Frete = 1,
    Values = 2,
}
